module.exports = __webpack_public_path__ + "media/images/icons/volume-low-78bd7ec796f47070165702e955486268.svg";